import { createGlobalStyle } from 'styled-components/macro';

export default createGlobalStyle`
    /* TODO: add global style here */
`;
